import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AskValue from "../global/BidAsk/AskValue";
import BidValue from "../global/BidAsk/BidValue";
import SpreadValue from "../global/BidAsk/SpreadValue";
import WatlistArrow from "../global/BidAsk/WatlistArrow";
import DailyChange from "../global/BidAsk/DailyChange";
import PercentageChange from "../global/BidAsk/PercentageChange";
import BidBuy from "../global/BidAsk/BidBuy";
import AskSell from "../global/BidAsk/AskSell";
import AmountInput from "../../MobileView/components/Quote/AmountInput";
import Time from "../global/BidAsk/Time";

const SymbolCell = () => {
  const { t } = useTranslation();
  const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
  const isOneClick = useSelector(state => state.watchlist?.isOneclick)
  const hasAgreed = useSelector(state => state?.watchlist?.isUserSigned)
  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const { userDetail } = useSelector((state) => state.user);
    const client = userDetail || {};
  const localHasAgreed = useMemo(() => { 
    try {
      const agreementKey = `oneClickTradingAgreement_${client.Id}`;
      const stored = localStorage.getItem(agreementKey);
      return stored && JSON.parse(stored)?.agreed === true;
    } catch {
      return false;
    }
  }, [client.Id]);

  const reduxAgreed = useSelector(state => state?.watchlist?.isUserSigned);
  // const hasAgreed = reduxAgreed && localHasAgreed;
  const columns = useMemo(() => (
    [
      {
        title: t("symbol"), width: 200, dataIndex: "name", render: (value, row) => (
          <div className="flex items-center justify-start" style={{ width: 500 }}>
            <WatlistArrow symbolId={row.id} />{row?.name}
          </div>
        ),
      },

      {
        title: t("bid"), width: 140, dataIndex: "bid", render: (value, row) =>
          value
            ? (hasAgreed && !isOneClick
              ? <BidBuy symbolId={row.id} digits={row?.digits} />
              : <BidValue symbolId={row.id} digits={row?.digits} />
            )
            : "--",
      },

      ...(hasAgreed && !isOneClick ? [
        { title: t("amount"), width: 120, dataIndex: "amount", render: (value, row) => <AmountInput symbolId={row.id} /> },
      ] : []),

      {
        title: t("ask"), width: 140, dataIndex: "ask", render: (value, row) =>
          value
            ? (hasAgreed && !isOneClick
              ? <AskSell symbolId={row.id} digits={row?.digits} />
              : <AskValue symbolId={row.id} digits={row?.digits} />
            )
            : "--",
      },
      { title: t("spread"), width: 100, dataIndex: "spread", render: (_, row) => <SpreadValue symbolId={row.id} />, },
      { title: t("netChange"), width: 100, dataIndex: "dailyChange", render: (_, row) => <DailyChange symbolId={row.id} digits={row.digits} />, },
      // { title: t("netChange"), width: 100, dataIndex: "low", render: (value, row) => (value ? <Low symbolId={row.id} digits={row?.digits} /> : "--"), },
      { title: t("percentage"), width: 100, dataIndex: "percentage", render: (_, row) => <PercentageChange symbolId={row.id} />, },

      { title: t("time"), width: 100, dataIndex: "lastQuoteTime", render: (_, row) => <Time symbolId={row.id} /> },
      { title: t("openPrice"), width: 100, dataIndex: "open", render: (value, row) => (value ? value.toFixed(row.digits) : "--"), },
      { title: t("closePrice"), width: 100, dataIndex: "close", render: (value, row) => (value ? value.toFixed(row.digits) : "--"), },
      { title: t("last"), width: 100, dataIndex: "last", render: (value, row) => (value ? value.toFixed(row.digits) : "--"), },
      { title: t("high"), width: 100, dataIndex: "high", render: (value, row) => (value ? value.toFixed(row.digits) : "--"), },
      { title: t("low"), width: 100, dataIndex: "low", render: (value, row) => (value ? value.toFixed(row.digits) : "--"), },
      {
        title: t("expiryDate"), width: 100, dataIndex: "expiryDate", render: (value, row) => {
          const expiryDate = row.tradingTimes?.expiryDate;
          return !expiryDate || expiryDate === "0001-01-01" ? " " : expiryDate;
        },
      },
      {
        title: t("maximumAmount"), width: 100, dataIndex: "maximumAmountPerDeal",
        render: (_, row) => {
          const symbolData = allSymbolParams?.[row.id];
          const max = symbolData?.maximumAmountPerDeal;
          return typeof max === 'number' ? max.toFixed(decimalPlaces) : "--";
        },
      },
      {
        title: t("minimumAmount"), width: 100, dataIndex: "minimumAmountPerDeal",
        render: (_, row) => {
          const symbolData = allSymbolParams?.[row.id];
          const min = symbolData?.minimumAmountPerDeal;
          return typeof min === 'number' ? min.toFixed(decimalPlaces) : "--";
        },
      },
      {
        title: t("initialMargin"), width: 100, dataIndex: "initialMargin",
        render: (_, row) => {
          const symbolData = allSymbolParams?.[row.id];
          const margin = symbolData?.initialMargin;
          const type = symbolData?.initialMarginType;
          if (typeof margin === 'number') { return `${margin}${type === 1 ? ' %' : ''}`; }
          return "--";
        },
      },

      { title: t("contractSize"), width: 100, dataIndex: "contractSize", render: (value, row) => (value ? value : "--"), },
    ]
  ), [hasAgreed, isOneClick, allSymbolParams, t]);

  return columns;
};

export default SymbolCell;